import { render, staticRenderFns } from "./StockAdjustmentList.vue?vue&type=template&id=54004e5b&"
import script from "./StockAdjustmentList.vue?vue&type=script&lang=ts&"
export * from "./StockAdjustmentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54004e5b')) {
      api.createRecord('54004e5b', component.options)
    } else {
      api.reload('54004e5b', component.options)
    }
    module.hot.accept("./StockAdjustmentList.vue?vue&type=template&id=54004e5b&", function () {
      api.rerender('54004e5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/stock-adjustment/StockAdjustmentList.vue"
export default component.exports